// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cropper-wrapper {
  max-width: 300px;
  max-height: 300px;
  padding: 0;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  --cropper-outline-color: rgba(12, 12, 12, 0.75)
}

image-cropper {
  width: 100% !important;
  height: 100% !important;
  max-width: 100%;
  max-height: 100%;
}

.avatar-wrapper {
  position: relative;
  width: 128px;
  height: 128px;
  margin: 10px auto;
}

/* Cerchio avatar */
.avatar-container {
  width: 100%;
  height: 100%;
  border: 3px solid var(--ion-color-primary);
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 8px;

  &.avatar-circle{
    border-radius: 50%;
    .avatar-image{
      border-radius: 50%;
    }
  }
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--ion-color-mid-light_base);
}

.avatar-placeholder-icon ion-icon {
  font-size: 34px; /* o quanto vuoi */
}

.camera-button {
  position: absolute;
  bottom: -10px;
  right: -10px;
  background-color: var(--ion-color-primary);
  color: white;
  border: 2px solid white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s ease;
  z-index: 10;

  &.camera-button-circle{
    bottom: 1px;
    right: -1px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/common/avatar-editor/avatar-editor.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;;EAElB;IACE,kBAAkB;IAClB;MACE,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,eAAe,EAAE,kBAAkB;AACrC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,0CAA0C;EAC1C,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;EACtC,WAAW;;EAEX;IACE,WAAW;IACX,WAAW;EACb;AACF","sourcesContent":[".cropper-wrapper {\n  max-width: 300px;\n  max-height: 300px;\n  padding: 0;\n  margin: 0 auto;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  --cropper-outline-color: rgba(12, 12, 12, 0.75)\n}\n\nimage-cropper {\n  width: 100% !important;\n  height: 100% !important;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.avatar-wrapper {\n  position: relative;\n  width: 128px;\n  height: 128px;\n  margin: 10px auto;\n}\n\n/* Cerchio avatar */\n.avatar-container {\n  width: 100%;\n  height: 100%;\n  border: 3px solid var(--ion-color-primary);\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  border-radius: 8px;\n\n  &.avatar-circle{\n    border-radius: 50%;\n    .avatar-image{\n      border-radius: 50%;\n    }\n  }\n}\n\n.avatar-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.avatar-placeholder-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: var(--ion-color-mid-light_base);\n}\n\n.avatar-placeholder-icon ion-icon {\n  font-size: 34px; /* o quanto vuoi */\n}\n\n.camera-button {\n  position: absolute;\n  bottom: -10px;\n  right: -10px;\n  background-color: var(--ion-color-primary);\n  color: white;\n  border: 2px solid white;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n  cursor: pointer;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.2s ease;\n  z-index: 10;\n\n  &.camera-button-circle{\n    bottom: 1px;\n    right: -1px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
